
import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { DashboardRoute } from './Layouts/Dashboard'
import { AuthenticationRoute } from './Layouts/Authentication'
import { HarasocialRoute } from './Layouts/Harasocial'

// Authentication Pages
import Login from 'Pages/Login'
import ForgotPassword from 'Pages/ForgotPassword'
import ResetPassword from 'Pages/ResetPassword'
import ActivateAccount from 'Pages/ActivateAccount'
import Policies from 'Pages/Policies'

// Main Pages
import { CampaignList, CampaignNew, CampaignDetail } from 'Pages/Campaign'
import { CreativeContentForm, CreativeContentList } from 'Pages/CreativeContent'
import Agents from 'Pages/Agents'

// Audience Pages
import { AudienceNew, AudienceList, AudienceDetails } from 'Pages/Audiences'

// Customer Pages

// Agent
import SettingAccount from 'Pages/SettingAccount'
import CustomerPortrait from 'Pages/Harasiocial/CustomerPortrait'
import LeaderBoard from 'Pages/Harasiocial/LeaderBoard'

// Utilities
import { GenerateQrCode } from 'Pages/Utilities'

//  Under Construction Page
import NotFound from 'Pages/NotFound'

// HARAVAN pages
import HaravanLoginSuccess from 'Pages/HaravanAuth/LoginSuccess'
import HaravanLoginFail from 'Pages/HaravanAuth/LoginFail'
import HarasocialInteraction from 'Pages/Harasiocial/HistoryInteraction'
import ForbidenPage from 'Pages/Forbiden'
import Test from 'Pages/TestPivot'
import TestChart from 'Pages/TestChart'
import LoginIAM from 'Pages/IAM'
import LoginFail from 'Pages/IAM/LoginFail'
// Analytics pages
import {
  MarketingCampaignsAnalytics,
  Campaign360,
  CustomersAnalytics,
  Segment360,
  Customer360,
  Product360,
  ProductsAnalytics,
  SaleAnalytics,
  Store360,
  Facebook360,
} from 'Pages/Analytics'
import CustomerListing from 'Pages/Analytics/Customers/ViewCustomerListing'

const Demo = () => {
  React.useEffect(() => {
    // console.log('Test')
  }, [])
  return (
    <div>
      <h1>Test</h1>
    </div>
  )
}

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <DashboardRoute exact path="/TestPivot" component={Test} />
      <DashboardRoute exact path="/TestChart" component={TestChart} />
      {/* Authentication Routes */}
      <AuthenticationRoute exact path="/login" component={Login} />
      <AuthenticationRoute exact path="/forgot-password" component={ForgotPassword} />
      <AuthenticationRoute exact path="/reset-password" component={ResetPassword} />
      {/* <AuthenticationRoute exact path="/register" component={Register} /> */}
      <AuthenticationRoute exact path="/activate-account" component={ActivateAccount} />

      {/* Dashboard Routes */}
      <DashboardRoute exact path="/campaigns" component={CampaignList} />
      <DashboardRoute exact path="/campaigns/new" component={CampaignNew} />
      <DashboardRoute exact path="/campaigns/:id" component={CampaignDetail} />
      <DashboardRoute exact path="/settings-account" component={SettingAccount}></DashboardRoute>

      {/* Utilities Routes */}
      <DashboardRoute exact path="/utilities/generate-qr-code" component={GenerateQrCode} />

      {/* Social selling */}
      {/* <DashboardRoute exact path="/social-selling" component={SocialSelling} /> */}

      {/* Store Farming  */}
      {/* <DashboardRoute exact path="/store-farming" component={StoreFarming} /> */}

      {/* Creative Content */}
      <DashboardRoute exact path="/creative-contents" component={CreativeContentList} />
      <DashboardRoute exact path="/creative-content/new" component={CreativeContentForm} />

      {/* Audience Routes */}
      <DashboardRoute exact path="/agents" component={Agents} />
      <DashboardRoute exact path="/customers/segments" component={AudienceList} />
      <DashboardRoute exact path="/customers/segments/new" component={AudienceNew} />
      <DashboardRoute exact path="/customers/segments/:id" component={AudienceDetails} />
      {/* <DashboardRoute
        exact
        path="/customers/segments/:id/analytics"
        component={Audience360Details}
      /> */}

      {/* <DashboardRoute exact path="/customers/360" component={CustomerList} /> */}
      {/* <DashboardRoute exact path="/customers/:id/customer360" component={CustomerAnalytics} /> */}

      {/* Haravan Routes */}
      <HarasocialRoute
        exact
        path="/harasocial/leader-board"
        Component={LeaderBoard}
      ></HarasocialRoute>
      <HarasocialRoute
        exact
        path="/harasocial/customer-portrait"
        Component={CustomerPortrait}
      ></HarasocialRoute>
      <HarasocialRoute
        exact
        path="/harasocial/interactions"
        Component={HarasocialInteraction}
      ></HarasocialRoute>
      <Route exact path="/login/haravan/success">
        <HaravanLoginSuccess></HaravanLoginSuccess>
      </Route>
      <Route exact path="/login/haravan/fail">
        <HaravanLoginFail></HaravanLoginFail>
      </Route>
      <Route exact path="/login/sso/success">
        <LoginIAM></LoginIAM>
      </Route>
      <Route exact path="/login/sso/fail">
        <LoginFail></LoginFail>
      </Route>
      {/* Analytics Routes */}
      <DashboardRoute exact path="/" component={CustomersAnalytics} />
      <DashboardRoute
        exact
        path="/analytics/marketing-campaigns"
        component={MarketingCampaignsAnalytics}
      />
      <DashboardRoute exact path="/analytics/campaign360/:id" component={Campaign360} />
      <DashboardRoute
        exact
        path="/analytics/campaign360/facebook-ads360/:id"
        component={Facebook360}
      />
      <DashboardRoute exact path="/analytics/customers" component={CustomersAnalytics} />
      <DashboardRoute exact path="/analytics/customer360/:id" component={Customer360} />
      <DashboardRoute exact path="/analytics/segment360/:id" component={Segment360} />
      <DashboardRoute exact path="/analytics/customer-list/:id" component={CustomerListing} />
      <DashboardRoute exact path="/analytics/products" component={ProductsAnalytics} />
      <DashboardRoute exact path="/analytics/product360/:id" component={Product360} />
      <DashboardRoute exact path="/analytics/sale-campaigns" component={SaleAnalytics} />
      <DashboardRoute exact path="/analytics/store360/:id" component={Store360} />

      {/* Policies Routes */}
      <Route path="/policies" component={Policies} />

      {/* 404 Routes */}
      <DashboardRoute exact path="/forbidden" component={ForbidenPage}></DashboardRoute>
      <Route component={NotFound} />
    </Switch>
  </BrowserRouter>
)

export default Routes
